import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { updateToastInfo } from '../../../../actions/settings';
import { updateSpinnerState } from '../../../../actions/spinner';
import ConfirmationModal from '../../../../components/common/confirmationModal';
import {
  getAllSchemes,
  updateSchemesStatus,
} from '../../../../parse-functions/sms/scheme';
import { useNavigate } from 'react-router-dom';
import SchemeInfoModal from '../Scheme/SchemeInfoModal';
import { infoTable } from '../../../../utils/sms/infoTable';
import DifferenceProductsModal from '../common/DifferenceProductsModal';
import BulkAddSchemeModal from '../BulkAddSchemeModal';
import BreadCrumbTitle from '../common/BreadCrumbTitle';
import {
  schemeTableRedesignColumns,
  ViewProductsTable,
} from '../../../../utils/sms/schemeTableRedesign';
import {
  faCircleCheck,
  faXmarkCircle,
} from '@fortawesome/free-regular-svg-icons';
import {
  faBan,
  faFileExport,
  faSliders,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, ButtonGroup, Form } from '@themesberg/react-bootstrap';
import TableOnly from '../IndividualScheme/TableOnly';
import { setSchemesDataInStore } from '../../../../actions/sms/schemes';
import { StyledSearchBar } from '../../../trips/styles';
import { setPageNumberInStore } from '../../../../actions/tablePage';
import { exportSchemeDataSummary } from '../../../../utils/sms/exportSchemeData';
import SchemeFilters from './SchemeFilters';
import { setSchemeOptionsInStore } from '../../../../actions/sms/schemeOptions';

const ActiveSchemes = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userName = useSelector((state) => state?.user?.user?.username || {});
  const isAdmin = useSelector(
    (state) => state?.user?.preferences?.isAdmin || false
  );
  const isBrandManager = useSelector(
    (state) => state?.user?.preferences?.isBrandManager || false
  );

  const isBrandVendor = useSelector(
    (state) => state?.user?.preferences?.isBrandVendor || false
  );

  const isAccountManager = useSelector(
    (state) => state?.user?.preferences?.isAccountManager || false
  );
  const schemes = useSelector((state) => state.schemes || {});
  const activeSchemeFilter = useSelector(
    (state) => state?.schemeOptions?.activeSchemeFilter || {}
  );

  const role = isAdmin
    ? 'isAdmin'
    : isBrandManager
    ? 'isBrandManager'
    : isBrandVendor
    ? 'isBrandVendor'
    : isAccountManager
    ? 'isAccountManager'
    : 'Unknown';
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [updateMode, setUpdateMode] = useState('');
  const [schemeData, setSchemeData] = useState(schemes.active || []);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [infoData, setInfoData] = useState();
  const [confirmationModalProps, setConfirmationModalProps] = useState([]);
  const [newProducts, setNewProducts] = useState([]);
  const [showDifferenceModal, setShowDifferenceModal] = useState(false);
  const [showProductsModal, setShowProductsModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [showFilterOptions, setShowFilterOptions] = useState(true);
  const [id, setId] = useState();

  let options = ['Action Timeline', 'View', 'Details', 'Pre-Closure', 'Clone'];

  const filteredData = schemeData?.filter((row) => {
    return Object.values(row).some((value) =>
      value?.toString()?.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  if (isBrandManager) {
    options.push(...['Edit', 'Complete', 'Cancel']);
  } else if (isBrandVendor) {
    options.push(...['Request Cancellation', 'Request Completion']);
  } else if (isAccountManager) {
    options.push(...['Close']);
  } else {
    options.push(...['Edit', 'Complete', 'Close', 'Cancel']);
  }
  const fetchActiveSchemes = async ({
    startDate,
    endDate,
    company,
    category,
    schemeType,
  }) => {
    try {
      dispatch(updateSpinnerState(true));
      if (startDate || endDate || company || category || schemeType) {
        dispatch(
          setSchemeOptionsInStore({
            type: 'activeSchemeFilter',
            data: { startDate, endDate, company, category, schemeType },
          })
        );
      }
      const response = await getAllSchemes({
        status: ['ongoing', 'completed'],
        role: role,
        startDate,
        endDate,
        company,
        category,
        schemeType,
      });
      if (response.length === 0) {
        throw new Error('No schemes found!');
      }
      setSchemeData(response);
      dispatch(setSchemesDataInStore({ type: 'active', data: response }));
    } catch (error) {
      dispatch(
        updateToastInfo({
          show: true,
          type: 'danger',
          title: 'Cannot fetch at the moment!',
          message: `${error.message}`,
        })
      );
    } finally {
      dispatch(updateSpinnerState(false));
    }
  };

  const handleShowDeleteModal = () => {
    setShowDeleteModal(true);
  };

  const handleSelectedRowUpdate = (actionId, row) => {
    switch (actionId) {
      case 'Complete': {
        setUpdateMode('Complete');
        setConfirmationModalProps([
          {
            type: 'textArea',
            title: t('Remarks'),
            value: '',
            placeholder: 'Enter Remarks',
          },
          // {
          //   type: 'date',
          //   title: t('Completion Date'),
          //   value: row.validTill,
          //   disabled: true,
          // },
          {
            headerIcon: <FontAwesomeIcon icon={faCircleCheck} />,
          },
        ]);
        setId(row.objectId);
        handleShowDeleteModal();
        break;
      }
      case 'Edit': {
        break;
        // navigate(`/scheme/${row.objectId}/edit`);
        // break;
      }
      case 'Clone': {
        dispatch(setSchemesDataInStore({ type: 'cloneSchemeData', data: row }));
        navigate('/redesignscheme/add/');
        break;
      }
      case 'Pre-Closure': {
        setUpdateMode('Pre-Closure');
        setConfirmationModalProps([
          {
            type: 'textArea',
            title: t('Remarks'),
            value: '',
            placeholder: 'Enter Remarks',
          },
          {
            type: 'date',
            title: t('Completion Date'),
            value: row.validTill,
          },
          {
            type: 'checkbox',
            title: t('Create Draft?'),
            value: false,
          },
          {
            headerIcon: <FontAwesomeIcon icon={faCircleCheck} />,
          },
        ]);
        setId(row.objectId);
        handleShowDeleteModal();
        break;
      }
      case 'Cancel': {
        setUpdateMode('Cancel');
        setConfirmationModalProps([
          {
            type: 'textArea',
            title: t('Remarks'),
            placeholder: 'Enter Remarks',
            value: '',
          },
          {
            headerIcon: <FontAwesomeIcon icon={faXmarkCircle} />,
          },
        ]);
        setId(row.objectId);
        handleShowDeleteModal();
        break;
      }
      case 'Request Cancellation': {
        setUpdateMode('Request Cancel');
        setConfirmationModalProps([
          {
            headerIcon: <FontAwesomeIcon icon={faXmarkCircle} />,
          },
        ]);
        setId(row.objectId);
        handleShowDeleteModal();
        break;
      }
      case 'Request Completion': {
        setUpdateMode('Request Complete');
        setConfirmationModalProps([
          {
            headerIcon: <FontAwesomeIcon icon={faCircleCheck} />,
          },
        ]);
        setId(row.objectId);
        handleShowDeleteModal();
        break;
      }
      case 'Close': {
        setUpdateMode('Close');
        setConfirmationModalProps([
          {
            type: 'textArea',
            title: t('Remarks'),
            placeholder: 'Enter Remarks',
            value: '',
          },
          {
            headerIcon: <FontAwesomeIcon icon={faBan} />,
          },
        ]);
        setId(row.objectId);
        handleShowDeleteModal();
        break;
      }
      case 'View': {
        navigate(`/scheme/${row.objectId}/details`);
        break;
      }
      case 'Details': {
        navigate(`/scheme/schemeanalysis/${row.objectId}`);
        break;
      }
      case 'Action Timeline': {
        setInfoData(row.actionLog);
        setShowInfoModal(true);
      }
      default: {
        break;
      }
    }
  };
  const handleOnConfirmClick = async (data) => {
    try {
      dispatch(updateSpinnerState(true));
      const result = await updateSchemesStatus(data);
      if (result[0].status === 'error') {
        setShowDifferenceModal(true);
        setNewProducts(result[0].difference);
        throw new Error(
          'There are new products that can be added to this scheme!'
        );
      }
      if (Object.keys(activeSchemeFilter).length > 0) {
        await fetchActiveSchemes(activeSchemeFilter);
      } else {
        await fetchActiveSchemes({});
      }

      setId();
      setConfirmationModalProps([]);

      dispatch(updateSpinnerState(false));
      dispatch(
        updateToastInfo({
          show: true,
          type: 'success',
          title: `Status Update Successful`,
          message: '',
        })
      );
      setShowDeleteModal(false);
      setShowDifferenceModal(false);
    } catch (e) {
      dispatch(updateSpinnerState(false));
      dispatch(
        updateToastInfo({
          show: true,
          type: 'danger',
          title: 'Status cannot be updated!',
          message: e.message,
        })
      );
    }
  };
  const handleModalOnConfirmClick = (data) => {
    const selectedSchemeData = {
      schemeId: [id],
      userName: userName,
      status:
        updateMode === 'Cancel'
          ? 'cancelled'
          : updateMode === 'Complete' || updateMode === 'Pre-Closure'
          ? 'completed'
          : updateMode === 'Close'
          ? 'closed'
          : 'ongoing',
      actionType:
        updateMode === 'Request Cancel'
          ? 'cancellation'
          : updateMode === 'Request Complete'
          ? 'completion'
          : '',
      reason: confirmationModalProps[0].value,
    };
    if (updateMode === 'Pre-Closure') {
      const newDate = confirmationModalProps[1].value;
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      yesterday.setHours(0, 0, 0, 0);

      if (newDate < yesterday) {
        dispatch(
          updateToastInfo({
            show: true,
            type: 'danger',
            title: 'Status cannot be updated!',
            message: 'Date cannot be less than yesterday.',
          })
        );
        return;
      }
      const oldDate = schemeData.find(
        (item) => item.objectId === id
      )?.validTill;

      if (oldDate.getTime() !== newDate.getTime()) {
        selectedSchemeData.completionDate = confirmationModalProps[1].value;
      }
      selectedSchemeData.createDraft = confirmationModalProps[2].value;
    }
    if (data) {
      selectedSchemeData.isChecked = true;
    }
    if (data?.length > 0) {
      selectedSchemeData.moreProducts = data;
    }
    handleOnConfirmClick(selectedSchemeData);
  };

  const handleMoreProductsClick = (id) => {
    setId(id);
    setShowProductsModal(true);
  };

  const handleSave = () => {
    let hasErrors = false;
    const data = newProducts.map((item) => {
      const updatedItem = { ...item, errors: {} };
      if (item.isSelected) {
        if (!item.payout) {
          updatedItem.errors.payout = 'Payout needs a value.';
          hasErrors = true;
        }
        if (!item.payoutBasis) {
          updatedItem.errors.payoutBasis = 'Payout Basis needs a value.';
          hasErrors = true;
        }
        if (!item.valuationType) {
          updatedItem.errors.valuationType = 'Valuation Type needs a value.';
          hasErrors = true;
        }
      }
      return updatedItem;
    });

    setNewProducts(data);
    if (!hasErrors) {
      handleModalOnConfirmClick(newProducts.filter((item) => item.isSelected));
    }
  };

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <BreadCrumbTitle breadcrumbs={[{ title: 'Active Schemes' }]} />
        </div>
        <div className="btn-toolbar mb-2 mb-md-0 gap-3">
          <StyledSearchBar
            width={'360.89px'}
            height={'46.78px'}
            type={'text'}
            value={searchTerm}
            placeholder={'Search value in the table'}
            onChange={(e) => {
              dispatch(
                setPageNumberInStore({ id: 'activeSchemesTable', page: 1 })
              );
              setSearchTerm(e.target.value);
            }}
          />
          <ButtonGroup className="gap-3">
            <Button
              variant={showFilterOptions ? 'primary' : 'white'}
              onClick={() => {
                setShowFilterOptions((prev) => !prev);
              }}
              size="md"
            >
              <FontAwesomeIcon icon={faSliders} />
              &nbsp;&nbsp;{t('Filter')}
            </Button>
            <Button
              variant={'white'}
              onClick={() => {
                exportSchemeDataSummary(schemeData, 'Active Schemes');
              }}
              disabled={schemeData.length === 0}
              size="md"
            >
              <FontAwesomeIcon icon={faFileExport} />
              &nbsp;&nbsp;{t('Export')}
            </Button>
          </ButtonGroup>
        </div>
      </div>
      {showFilterOptions && (
        <SchemeFilters
          onSubmit={fetchActiveSchemes}
          defaultFilter={activeSchemeFilter}
        />
      )}
      {/* <div
        className="d-flex align-items-center p-2 mb-2"
        style={{
          width: '125px',
          height: '38px',
          borderRadius: 0,
          backgroundColor: 'white',
        }}
      >
        <Form.Group>
          <Form.Check
            type="checkbox"
            label="Select All"
            checked={selectAll}
            onChange={selectAllClicked}
          />
        </Form.Group>
      </div> */}
      <TableOnly
        data={filteredData || []}
        columns={schemeTableRedesignColumns({
          handleMoreProductsClick,
          options: options,
          handleSelectedRowUpdate,
        })}
        id={'activeSchemesTable'}
      />
      <ConfirmationModal
        showModal={showDeleteModal}
        onConfirm={() => handleModalOnConfirmClick()}
        closeModal={() => {
          setShowDeleteModal(false);
          setConfirmationModalProps([]);
        }}
        modalBody={t(`Are you sure you want to ${updateMode?.toLowerCase()}?`)}
        modalTitle={t(`${updateMode} Scheme(s)`)}
        confirmationModalProps={confirmationModalProps}
        setConfirmationModalProps={setConfirmationModalProps}
      />
      <SchemeInfoModal
        showModal={showInfoModal}
        closeModal={() => setShowInfoModal(false)}
        data={infoData}
        columns={infoTable()}
      />
      <DifferenceProductsModal
        showModal={newProducts.length > 0 && showDifferenceModal}
        closeModal={() => setShowDifferenceModal(false)}
        data={newProducts}
        setNewProducts={setNewProducts}
        handleSave={handleSave}
      />
      {showProductsModal && (
        <BulkAddSchemeModal
          data={
            schemeData?.filter((item) => item.objectId === id)[0]?.products ||
            []
          }
          showModal={showProductsModal}
          closeModal={() => setShowProductsModal(false)}
          columns={ViewProductsTable(
            schemeData?.filter((item) => item.objectId === id)[0]
          )}
        />
      )}
    </>
  );
};
export default ActiveSchemes;
